import { QueryClient } from '@tanstack/react-query';

// Shared app-wide query cache. Lives in its own module (not App.tsx) so
// non-React code — the axios write interceptor in api/client.ts — can reach
// it to invalidate caches after mutations.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Serve cached data for a minute before even background-refreshing;
      // after that, revisits still render instantly from cache while the
      // refresh runs. Cache entries live 30 min after last use. Writes
      // invalidate everything immediately (see api/client.ts), so staleTime
      // never delays seeing your own changes.
      staleTime: 60_000,
      gcTime: 30 * 60_000,
      // One retry, not the default three — a genuinely down backend should
      // surface as an error in a few seconds, not after ~15s of backoff.
      retry: 1,
    },
  },
});
